import { useEffect } from "react";
import { useTheme } from "@/context/ThemeContext";

/**
 * Force dark mode for the lifetime of the component that calls this hook.
 * Uses the ThemeContext's push/pop counter so it survives ThemeProvider's
 * own effect (which would otherwise re-remove the .dark class on next
 * render, since children's effects run before their parents').
 *
 * Applied on public/marketing screens (Landing, Login, Register, Privacy,
 * PublicDocuments) which are hard-coded dark-first with bg-[#0A0F1C] +
 * text-white. Without this, users whose in-app theme is Light see a
 * muddy grey header with unreadable dark text because the light-mode
 * safety-net remaps text-white → dark but not the alpha-variant
 * dark backgrounds (bg-[#0A0F1C]/60 etc.).
 *
 * Does NOT persist to localStorage — the user's chosen theme is left alone.
 */
export function useForceDark() {
  const { pushForceDark, popForceDark } = useTheme();
  useEffect(() => {
    pushForceDark();
    return () => popForceDark();
  }, [pushForceDark, popForceDark]);
}
